import { PrismicManager } from "./PrismicManager.js";
const createPrismicManager = (...args) => {
  return new PrismicManager(...args);
};
export {
  createPrismicManager
};
//# sourceMappingURL=createPrismicManager.js.map
